export default __webpack_public_path__ + "static/media/radio-unchecked.22e69286.svg";